export const UPDATE_SHIPPING_METHOD_REQUEST = 'UPDATE_SHIPPING_METHOD_REQUEST'
export const UPDATE_SHIPPING_METHOD_SUCCESS = 'UPDATE_SHIPPING_METHOD_SUCCESS'
export const UPDATE_SHIPPING_METHOD_FALIURE = 'UPDATE_SHIPPING_METHOD_FALIURE'
export const AVAILABLE_SHIPPING_METHOD_SUCCESS = 'AVAILABLE_SHIPPING_METHOD_SUCCESS'
